<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs10>
        <v-card class="text-xs-center">

          <basic-toolbar title="Relatório para seguro"></basic-toolbar>

          <v-card-text>
            <v-form v-model="formularioValido" ref="form">
              <v-container>

                <v-layout row wrap>
                  <v-flex xs12>
                    <v-checkbox label="Alunos" v-model="relatorio.tipo" :value="1"></v-checkbox>
                    <v-checkbox label="Externos" v-model="relatorio.tipo" :value="2"></v-checkbox>
                  </v-flex>
                </v-layout>

                <v-layout row wrap>
                  <v-flex xs11 sm5>
                    <v-text-field type="date" label="Data de início" v-model="relatorio.dataInicial" required :rules="regrasBasicas"></v-text-field>
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-flex xs11 sm5>
                    <v-text-field type="date" label="Data de conclusão" v-model="relatorio.dataFinal" :rules="regrasBasicas"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>

            <v-divider></v-divider>

            <v-card-actions>
              <v-btn color="primary" text @click="cancelar()">Cancelar</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="baixar()" :disabled="!formularioValido">Baixar</v-btn>
            </v-card-actions>

          </v-card-text>

        </v-card>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import BasicToolbar from '@/components/toolbars/basic-toolbar'
  import { mapActions } from 'vuex'

  export default {
    props: ['idProjeto'],
    data: () => ({
      api_url: process.env.API_BASE_URL,
      formularioValido: false,
      relatorio: {
        tipo: [],
        dataInicial: null,
        dataFinal: null
      },
      regrasBasicas: [
        (input) => !!input || 'Este campo é obrigatório'
      ]
    }),
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
      cancelar: function () {
        this.$router.go(-1)
      },
      baixar: function () {
        const urlRelatorio = new URL(this.api_url + '/gestao/seguro.xlsx')
        urlRelatorio.searchParams.append('tipo', this.relatorio.tipo)
        urlRelatorio.searchParams.append('dataInicial', this.relatorio.dataInicial)
        urlRelatorio.searchParams.append('dataFinal', this.relatorio.dataFinal)

        window.location = urlRelatorio.href
      }
    },
    mounted () {
    },
    components: {
      'basic-toolbar': BasicToolbar
    }
  }
</script>



// WEBPACK FOOTER //
// relatorio-seguro.vue?4c5d8b98